import React from 'react';
import Flagship from '../../core/flagship';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import '../../styles/commentBox.scss';
import { Popup, Button, Image } from 'semantic-ui-react';
import SubscribeUserModal from "../modals/SubscribeUserModal";

class SubscribeButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.subscribeButton = this.subscribeButton.bind(this);
        this.userIsSubscribed = this.userIsSubscribed.bind(this);
        this.subscribeMe = this.subscribeMe.bind(this);
        this.subscribeOther = this.subscribeOther.bind(this);
        this.unsubscribeMe = this.unsubscribeMe.bind(this);
        this.subscribingUser = this.subscribingUser.bind(this);
    }

    getInitialState() {
        return {
            subscribers: this.props.subscribers,
            hovering: false,
            subscribingUser: false
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            subscribers: nextProps.subscribers
        })
    }

    userIsSubscribed() {
        let userIsSubscribed = false;
        let currentUserId = this.props.userId;

        if ( this.state.subscribers.length > 0 ){
            this.state.subscribers.map(function(subscriber) {
                if (parseInt(subscriber.user_id) === currentUserId) {
                    userIsSubscribed = true;
                }
            });
        }
        return userIsSubscribed;
    }

    subscribingUser(value = true) {
        this.setState({
            subscribingUser: value
        })
    }

    subscribeOther(userId) {

        let recordId = this.props.recordId;

        let self = this;

        Flagship.post(
            'subscribe/' + recordId + '/' + userId,
            {},
            function(response) {

                if (response.data.success === true) {
                    self.setState({
                       subscribers:
                            [...self.state.subscribers,
                            {
                                user_id: response.data.user.user.id,
                                photo: response.data.user.user.photo,
                                username: response.data.user.user.username,
                                first_name: response.data.user.user.first_name,
                                last_name: response.data.user.user.last_name
                            }]
                    });
                    Flagship.notify("Subscribed " + response.data.user.user.first_name + ".", "success");

                } else {
                    Flagship.error("Failed to add other user as subscriber.", recordId, userId);
                }
            }
        );
    }

    subscribeMe() {

        let recordId = this.props.recordId;
        let userId = this.props.userId;

        let self = this;

        Flagship.post(
            'subscribe/' + recordId + '/' + userId,
            {},
            function(response) {

                if (response.data.success === true) {
                    self.setState({
                        subscribers:
                            [...self.state.subscribers,
                                {
                                    user_id: response.data.user.user.id,
                                    photo: response.data.user.user.photo,
                                    username: response.data.user.user.username,
                                    first_name: response.data.user.user.first_name,
                                    last_name: response.data.user.user.last_name
                                }]
                    });
                    Flagship.notify("Subscribed to updates.", "success");

                } else {
                    Flagship.error("Failed to add subscriber.", recordId, userId);
                }
            }
        );
    }

    unsubscribeMe() {

        let recordId = this.props.recordId;
        let userId = this.props.userId;
        let self = this;
        Flagship.post(
            'unsubscribe/' + recordId + '/' + userId,
            {},
            function (response) {
                if (response.data.success === true) {

                    let trimmedSubscribers = self.state.subscribers.filter(function(user) {
                        return parseInt(user.user_id) !== userId;
                    });

                    self.setState({
                       subscribers: trimmedSubscribers
                    });

                    Flagship.notify("Unsubscribed.");
                } else {
                    Flagship.error("Failed to remove subscriber.", recordId, userId);
                }
            }
        );
    }

    showCurrentSubscribers() {
        if (this.state.subscribers.length === 0 ) {
            return (
                <div className="subscriber-list">
                    Click to subscribe to updates.
                </div>
            )
        } else {
            return (

                <div className="subscriber-list">
                    <h4>Current Subscribers</h4>
                    {this.state.subscribers.map(function(subscriber, i) {
                        return (
                            <div key={"subscriber-" + i} className="single-subscriber">
                                <Image src={Flagship.config.uploads + subscriber.photo} avatar />
                                <span className="subscriber-name">{subscriber.first_name} {subscriber.last_name}</span>
                            </div>
                        );
                    })}
                    <span></span>
                </div>
            );
        }
    }

    subscribeUserModal() {
        return (
            <SubscribeUserModal
                subscribingUser={this.subscribingUser}
                subscribeOther={this.subscribeOther}
                recordNiceName={this.props.recordNiceName}
            />
        );
    }

    subscribeOtherButton() {
        return (
                <Button
                    color="teal"
                    floated="right"
                    icon="user"
                    content="Subscribe Someone Else"
                    onClick={() => {this.setState(
                        {
                            subscribingUser:true
                        }
                    )}}
                />
        );
    }

    subscribeButton() {
        if ( this.userIsSubscribed() ) {
            return (
                <span
                    onMouseEnter={() => {this.setState({hovering:true})}}
                    onMouseLeave={() => {this.setState({hovering:false})}}
                    className="float-right"
                >
                    <Button
                        className="subscribe-button subscribed"
                        content="Subscribed"
                        icon='bell'
                        floated='right'
                        onClick={this.unsubscribeMe}

                    />
                    {this.state.hovering ?
                    this.subscribeOtherButton()
                    :
                    null
                    }
                    {this.state.subscribingUser ?
                        this.subscribeUserModal()
                        :
                        null
                    }

                </span>
            );
        } else {
            return (
                <span
                    onMouseEnter={() => {this.setState({hovering:true})}}
                    onMouseLeave={() => {this.setState({hovering:false})}}
                    className="float-right"
                >
                    <Button
                        className="subscribe-button unsubscribed"
                        content={"Subscribe" + (this.state.hovering ? " Me" : '')}
                        icon='bell'
                        floated='right'
                        onClick={this.subscribeMe}
                    />
                    {this.state.hovering ?
                        this.subscribeOtherButton()
                        :
                        null
                    }
                    {this.state.subscribingUser ?
                        this.subscribeUserModal()
                        :
                        null
                    }
                </span>
            );
        }

    }

    render() {
        return (
            <Popup
                trigger={this.subscribeButton()}
                position="bottom right"
                content={this.showCurrentSubscribers()}
            />

        );

    }
}

SubscribeButton.propTypes = {
    actions: PropTypes.object,
    username: PropTypes.string,
    userId: PropTypes.number
};

function mapStateToProps(state) {
  return {
      username: state.main.username,
      userId: state.main.userId,
  };
}


export default connect(
  mapStateToProps,
  null,
)(SubscribeButton);





// WEBPACK FOOTER //
// ./src/components/records/SubscribeButton.js